"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMinHeap = generateMinHeap;
exports.heapIterator = heapIterator;
var _heap = _interopRequireDefault(require("heap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * heapIterator - get an iterator getting the next minimum item in the heap on each iteration
 *
 * @param  {MinHeap<U>} heap - the heap to iterate through
 *
 * @returns Iterable<U> - the iterator
 */
function* heapIterator(heap) {
  while (!heap.empty()) {
    // $FlowIgnore[incompatible-type] - pop is optional because it will return undefined when empty, with the check above, there will always be an item
    yield heap.pop();
  }
}

/**
 * generateMinHeap - get a minimum heap with the startingItems
 *
 * @param  {U[]} startingItems - the items to start in the heap
 * @param  {(item1:U,item2:U)=>number} comparer - the function used to determine the order of the items. Should return a negative number if item1 comes before item2.
 *
 * @returns MinHeap
 */
function generateMinHeap(startingItems, comparer) {
  const heap = new _heap.default(comparer);
  for (let i = 0; i < startingItems.length; i++) {
    heap.push(startingItems[i]);
  }
  return heap;
}